import { environment } from '../../environments/environment';
import { ProjectPhase } from '../shared/model/general/ProjectPhase';

export enum ProjectDetailsTab {
  debug = 'debug',
  overview = 'overview',
  timeline = 'timeline',
  report = 'report',
    powerBiProject = 'powerBiProject',
    powerBiFinancialDevexProject = 'powerBiFinancialDevexProject',
  info = 'info',
    general = 'general',
    location = 'location',
    businessModel = 'businessModel',
    routeToMarket = 'routeToMarket',
    strategy = 'strategy',
    optimisation = 'optimisation',
  team = 'team',
  construction = 'construction',
    keyEvents = 'keyEvents',
    gradeOfCompletion = 'gradeOfCompletion',
    issuesRisks = 'issuesRisks',
    claimsVariations = 'claimsVariations',
    constructionFinance = 'constructionFinance',
    hse = 'hse',
    waste = 'waste',
    punctuality = 'punctuality',
  schedule = 'schedule',
  matrix = 'matrix',
  finance = 'finance',
    value = 'value',
    lifetime = 'lifetime',
    opex = 'opex',
    capex = 'capex',
    revenue = 'revenue',
    cashflow = 'cashflow',
    financialModel = 'financialModel',
  technical = 'technical',
    techTotal = 'techTotal',
    grid = 'grid',
    windOnshore = 'windOnshore',
    solar = 'solar',
    storage = 'storage',
  tasks = 'tasks',
  lessonsLearnt = 'lessonsLearnt',
  changelog = 'changelog',
}
export const tabsByPhase: {[phase: string]: ProjectDetailsTab[]} = {
  [ProjectPhase.DEVELOPMENT]: [
    ProjectDetailsTab.overview,
    ProjectDetailsTab.timeline,
    ProjectDetailsTab.report,
    ProjectDetailsTab.info,
    ProjectDetailsTab.team,
    ProjectDetailsTab.matrix,
    ProjectDetailsTab.schedule,
    ProjectDetailsTab.finance,
    ProjectDetailsTab.technical,
    ProjectDetailsTab.tasks,
    ProjectDetailsTab.lessonsLearnt,
    ProjectDetailsTab.changelog,
  ],
  [ProjectPhase.CONSTRUCTION]: [
    ProjectDetailsTab.overview,
    ProjectDetailsTab.timeline,
    ProjectDetailsTab.report,
    ProjectDetailsTab.info,
    ProjectDetailsTab.team,
    ProjectDetailsTab.construction,
    ProjectDetailsTab.schedule,
    ProjectDetailsTab.finance,
    ProjectDetailsTab.technical,
    ProjectDetailsTab.tasks,
    ProjectDetailsTab.lessonsLearnt,
    ProjectDetailsTab.changelog,
    ProjectDetailsTab.matrix,
  ],
  [ProjectPhase.OPERATIONS]: [
    ProjectDetailsTab.overview,
    ProjectDetailsTab.timeline,
    ProjectDetailsTab.info,
    ProjectDetailsTab.team,
    ProjectDetailsTab.construction,
    ProjectDetailsTab.schedule,
    ProjectDetailsTab.finance,
    ProjectDetailsTab.technical,
    ProjectDetailsTab.tasks,
    ProjectDetailsTab.lessonsLearnt,
    ProjectDetailsTab.changelog,
    ProjectDetailsTab.matrix,
  ],
};
export interface ProjectDetailsTabData {
  id: ProjectDetailsTab;
  parentId: ProjectDetailsTab;
  label: string;
  editable: boolean;
  fullscreen: boolean;
  embeddedFullscreen: boolean;
  accessibleByAll: boolean;
  hasSubTabs: boolean;
  deactivated?: boolean;
}
export const ProjectDetailsTabDataMap: {[tab: string]: ProjectDetailsTabData} = {
  [ProjectDetailsTab.debug]: {
    id: ProjectDetailsTab.debug,
    parentId: null,
    label: 'Debug',
    editable: false,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: true,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.overview]: {
    id: ProjectDetailsTab.overview,
    parentId: null,
    label: 'Overview',
    editable: false,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: true,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.timeline]: {
    id: ProjectDetailsTab.timeline,
    parentId: null,
    label: 'Timeline',
    editable: false,
    fullscreen: true,
    embeddedFullscreen: true,
    accessibleByAll: true,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.report]: {
    id: ProjectDetailsTab.report,
    parentId: null,
    label: 'Report',
    editable: false,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: true,
  },
  [ProjectDetailsTab.powerBiProject]: {
    id: ProjectDetailsTab.powerBiProject,
    parentId: ProjectDetailsTab.report,
    label: 'Project<br>Report',
    editable: false,
    fullscreen: true,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.powerBiFinancialDevexProject]: {
    id: ProjectDetailsTab.powerBiFinancialDevexProject,
    parentId: ProjectDetailsTab.report,
    label: 'Financial<br>Report',
    editable: false,
    fullscreen: true,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.info]: {
    id: ProjectDetailsTab.info,
    parentId: null,
    label: 'Project<br>Information',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: false,
    accessibleByAll: false,
    hasSubTabs: true,
  },
  [ProjectDetailsTab.general]: {
    id: ProjectDetailsTab.general,
    parentId: ProjectDetailsTab.info,
    label: 'General Data',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: false,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.location]: {
    id: ProjectDetailsTab.location,
    parentId: ProjectDetailsTab.info,
    label: 'Location Data',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: false,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.businessModel]: {
    id: ProjectDetailsTab.businessModel,
    parentId: ProjectDetailsTab.info,
    label: 'Business Model<br>& Divestment',
    editable: true,
    fullscreen: true,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.routeToMarket]: {
    id: ProjectDetailsTab.routeToMarket,
    parentId: ProjectDetailsTab.info,
    label: 'Route to Market',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: false,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.strategy]: {
    id: ProjectDetailsTab.strategy,
    parentId: ProjectDetailsTab.info,
    label: 'Project Strategy',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: false,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.optimisation]: {
    id: ProjectDetailsTab.optimisation,
    parentId: ProjectDetailsTab.info,
    label: 'Optimisation Plan',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: false,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.team]: {
    id: ProjectDetailsTab.team,
    parentId: null,
    label: 'Project<br>Team',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.construction]: {
    id: ProjectDetailsTab.construction,
    parentId: null,
    label: 'Construction',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: true,
  },
  [ProjectDetailsTab.keyEvents]: {
    id: ProjectDetailsTab.keyEvents,
    parentId: ProjectDetailsTab.construction,
    label: 'Key Events',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.gradeOfCompletion]: {
    id: ProjectDetailsTab.gradeOfCompletion,
    parentId: ProjectDetailsTab.construction,
    label: 'Grade of<br>Completion',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.issuesRisks]: {
    id: ProjectDetailsTab.issuesRisks,
    parentId: ProjectDetailsTab.construction,
    label: 'Issues<br>&amp; Risks',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.claimsVariations]: {
    id: ProjectDetailsTab.claimsVariations,
    parentId: ProjectDetailsTab.construction,
    label: 'Claims<br>&amp; Variations',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.constructionFinance]: {
    id: ProjectDetailsTab.constructionFinance,
    parentId: ProjectDetailsTab.construction,
    label: 'Finance',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.hse]: {
    id: ProjectDetailsTab.hse,
    parentId: ProjectDetailsTab.construction,
    label: 'HSE',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.waste]: {
    id: ProjectDetailsTab.waste,
    parentId: ProjectDetailsTab.construction,
    label: 'Waste<br>Management',
    editable: true,
    fullscreen: true,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.punctuality]: {
    id: ProjectDetailsTab.punctuality,
    parentId: ProjectDetailsTab.construction,
    label: 'COD<br>Punctuality',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.matrix]: {
    id: ProjectDetailsTab.matrix,
    parentId: null,
    label: 'Development<br>Stage Matrix',
    editable: true,
    fullscreen: true,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.schedule]: {
    id: ProjectDetailsTab.schedule,
    parentId: null,
    label: 'Schedule',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.finance]: {
    id: ProjectDetailsTab.finance,
    parentId: null,
    label: 'Financial',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: true,
  },
  [ProjectDetailsTab.value]: {
    id: ProjectDetailsTab.value,
    parentId: ProjectDetailsTab.finance,
    label: 'Value',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.lifetime]: {
    id: ProjectDetailsTab.lifetime,
    parentId: ProjectDetailsTab.finance,
    label: 'Costs - Lifetime',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.opex]: {
    id: ProjectDetailsTab.opex,
    parentId: ProjectDetailsTab.finance,
    label: 'Costs - OPEX',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.capex]: {
    id: ProjectDetailsTab.capex,
    parentId: ProjectDetailsTab.finance,
    label: 'Costs - CAPEX',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.revenue]: {
    id: ProjectDetailsTab.revenue,
    parentId: ProjectDetailsTab.finance,
    label: 'Revenue',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.cashflow]: {
    id: ProjectDetailsTab.cashflow,
    parentId: ProjectDetailsTab.finance,
    label: 'Cashflow',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.financialModel]: {
    id: ProjectDetailsTab.financialModel,
    parentId: ProjectDetailsTab.finance,
    label: 'Financial Model',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.technical]: {
    id: ProjectDetailsTab.technical,
    parentId: null,
    label: 'Technical',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: true,
  },
  [ProjectDetailsTab.techTotal]: {
    id: ProjectDetailsTab.techTotal,
    parentId: ProjectDetailsTab.technical,
    label: 'Totals',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.grid]: {
    id: ProjectDetailsTab.grid,
    parentId: ProjectDetailsTab.technical,
    label: 'Grid',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.windOnshore]: {
    id: ProjectDetailsTab.windOnshore,
    parentId: ProjectDetailsTab.technical,
    label: 'Technology - Wind-Onshore',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.solar]: {
    id: ProjectDetailsTab.solar,
    parentId: ProjectDetailsTab.technical,
    label: 'Technology - Solar',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.storage]: {
    id: ProjectDetailsTab.storage,
    parentId: ProjectDetailsTab.technical,
    label: 'Technology - Storage',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.tasks]: {
    id: ProjectDetailsTab.tasks,
    parentId: null,
    label: 'Tasks',
    editable: true,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
  [ProjectDetailsTab.lessonsLearnt]: {
    id: ProjectDetailsTab.lessonsLearnt,
    parentId: null,
    label: 'Lessons<br>Learnt',
    editable: true,
    fullscreen: true,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
    deactivated: environment.production,
  },
  [ProjectDetailsTab.changelog]: {
    id: ProjectDetailsTab.changelog,
    parentId: null,
    label: 'Change<br>Log',
    editable: false,
    fullscreen: false,
    embeddedFullscreen: true,
    accessibleByAll: false,
    hasSubTabs: false,
  },
};
